import { Theme, Components } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiPickersInputBase: Components<Theme>['MuiPickersInputBase'] = {
  defaultProps: {
    size: 'medium',
  },
  styleOverrides: {
    root: {
      variants: [
        {
          props: { size: 'small' },
          style: {
            height: 'var(--input-height-small)',
            '.MuiPickersInputBase-sectionsContainer': {
              paddingTop: 0,
              paddingBottom: 0,
            },
          },
        },
        {
          props: { size: 'medium' },
          style: {
            height: 'var(--input-height-medium)',
            '.MuiPickersInputBase-sectionsContainer': {
              paddingTop: 0,
              paddingBottom: 0,
            },
          },
        },
      ],
      font: scssVariables.FontBodyRegular,
      input: {
        '&::placeholder': {
          color: scssVariables.ColorBlack60,
        },
      },
      ':has(.Mui-disabled)': {
        cursor: 'not-allowed',
        backgroundColor: scssVariables.ColorBlack20,
        '.MuiPickersSectionList-root span': {
          color: scssVariables.ColorBlack60,
        },

        input: {
          cursor: 'not-allowed',
        },

        '.MuiInputAdornment-root': {
          // make color consistent with disabled input text
          color: scssVariables.ColorBlack60,
          '.MuiTypography-root': {
            color: scssVariables.ColorBlack60,
          },
        },
      },
    },
  },
};
